import { createStore } from "redux";

import appReducer from "./reducers";

// tslint:disable-next-line: no-any
const windowIfDefined = typeof window === "undefined" ? {} : (window as any);
const devtool = windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__?.();

const store = createStore(appReducer, devtool);

export { store };
